import { createAction } from 'redux-actions';

export const changeDirectionToLTR = createAction('CHANGE_DIRECTION_TO_LTR');
export const changeDirectionToRTL = createAction('CHANGE_DIRECTION_TO_RTL');
